import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
    map,
    Observable,
    Subscription
} from 'rxjs';

import { Router } from '@angular/router';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { TFACodeVerificationRequestData } from '../../../../auth/models/auth.interfaces';
import { TwoFactorAuthenticationSetup } from '../models/TwoFactorAuthenticationSetup';

@Injectable()
export class TwoFactorAuthenticationService implements OnDestroy {
    private _baseUrl = '/api/2fa/';
    private _subscriptions: Subscription[] = [];

    constructor(
        private http: HttpClient,
        private _router: Router,
        private _endPointService: EndPointService
    ) {
        this.registerEndPoints();
    }

    private registerEndPoints(): void {
        this._endPointService.registerEndPoint<boolean>(
            'is-required',
            `${this._baseUrl}isRequired`,
            true
        );
        this._endPointService.registerEndPoint<TwoFactorAuthenticationSetup>(
            'is-setup',
            `${this._baseUrl}isSetup`,
            true
        );
        this._endPointService.registerEndPoint<TwoFactorAuthenticationSetup>(
            'setup-code',
            `${this._baseUrl}getSetupCode`,
            true
        );
        this._endPointService.registerEndPoint<any>(
            'verify',
            `${this._baseUrl}verify`,
            true
        );
        this._endPointService.registerEndPoint<boolean>(
            'verifyEntryCode',
            `${this._baseUrl}verifyEntryCode`,
            true
        );
    }

    public isRequired(fetch?: boolean): Observable<boolean> {
        return this._endPointService.call<boolean>(
            'is-required',
            null,
            fetch
        );
    }

    public isSetup(fetch?: boolean): Observable<boolean> {
        return this._endPointService.call<boolean>(
            'is-setup',
            null,
            fetch
        );
    }

    public getSetupCode(fetch?: boolean): Observable<TwoFactorAuthenticationSetup> {
        return this._endPointService.call<TwoFactorAuthenticationSetup>(
            'setup-code',
            null,
            fetch
        );
    }

    public verify(requestData: TFACodeVerificationRequestData, fetch?: boolean): Observable<string> {
        return this._endPointService.call<any>(
            'verify',
            requestData,
            fetch
        ).pipe(map(e => e.code));
    }

    ngOnDestroy(): void {
        for (const subscription of this._subscriptions) {
            subscription.unsubscribe();
        }
    }
}
